<template>
	<div class="col-12 d-flex justify-content-center">
		<div class="col-10 col-md-6 col-lg-4 rounded-10 pl-0 pr-0 background-white box-shadow d-flex text-center ">
			<div class="col-12 pl-4 pr-4 bot-bg-login">
				<div class="row">
					<div class="col-12 mt-4 mb-4">
						<h4 class="text-purple mt-4 mb-3 font-size-16">MASUK</h4>
					</div>
				</div>
				<form role="form" v-on:submit.prevent="onLogin" v-show="!showOTP">
					<div class="row">
						<div class="col-12 col-md-10 offset-md-1">
							<ml-alert v-for="alert in this.alerts" :key="alert.id" :type="alert.type" :message="alert.message" @close="removeAlert(alert.id)" close/>
							<img src="/assets/login/profile_login.png" class="position-absolute img-login">
							<input type="text" name="" placeholder="Kode Mobile Counter" class="form-control font-size-11 no-border log-box-shadow text-gray box-purple pl-5 pr-5" v-model="username">
							<div class="invalid-feedback d-block text-left" v-if="this.fieldErrors.username">Username {{ this.fieldErrors.username }} </div>
						</div>
					</div>
					<div class="row">
						<div class="col-12 col-md-10 offset-md-1 pt-4">
							<img src="/assets/login/lock_login.png" class="position-absolute img-login">
							<input type="password" name="" placeholder="Kata Sandi" class="form-control font-size-11 no-border log-box-shadow text-gray box-purple pl-5 pr-5" id="in-password" v-model="password">
							<span @click="showPassword" class="text-right position-absolute cursor-pointer icon-password">
								<span v-show="sPassword"><i class="far fa-eye"></i></span>
								<span v-show="!sPassword"><i class="far fa-eye-slash"></i></span>
							</span>
							<div class="invalid-feedback d-block text-left" v-if="this.fieldErrors.password">Password {{ this.fieldErrors.password }} </div>
						</div>
					</div>
					<div class="row">
						<div class="col-12 pt-2 mt-2">
							<div class="row">
								<div class="col-8 offset-2 col-md-6 offset-md-3 mt-4 pb-5">
									<button type="submit" class="btn btn-mila btn-block text-white box-purple" :disabled="isAttempting"><img src="/assets/login/login.png" class="img-fluid pr-2">{{ isAttempting ? 'Proses...' : 'MASUK'}}</button>
								</div>
							</div>
						</div>
					</div>
				</form>
				<form role="form" v-on:submit.prevent="onOtp" v-show="showOTP">
					<div class="row">
						<div class="col-12 col-md-10 offset-md-1 pt-4">
							<img src="/assets/login/lock_login.png" class="position-absolute img-login">
							<input type="text" name="" placeholder="Kode OTP" class="form-control font-size-11 no-border log-box-shadow text-gray box-purple pl-5 pr-5" v-model="otpCode">
							<div class="invalid-feedback d-block text-left" v-if="this.fieldErrors.otp_code">OTP {{ this.fieldErrors.otp_code }} </div>
						</div>
					</div>
					<div class="row">
						<div class="col-12 pt-2 mt-2">
							<div class="row">
								<div class="col-8 offset-2 col-md-6 offset-md-3 mt-4 pb-5">
									<button type="submit" class="btn btn-mila btn-block text-white box-purple" :disabled="isAttempting"><img src="/assets/login/login.png" class="img-fluid pr-2">{{ isAttempting ? 'Proses...' : 'MASUK'}}</button>
								</div>
							</div>
						</div>
					</div>
				</form>
			</div>
		</div>
	</div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapState, mapMutations, mapActions } = createNamespacedHelpers('auth');

export default {
	data() {
		return {
			username: '',
			password: '',
			otpCode: '',
			sPassword: true,
			showOTP: false,
		}
	},
	computed: {
		...mapState(['isAttempting', 'fieldErrors', 'alerts']),
	},
	methods: {
		...mapMutations(['removeAlert', 'reset']),
		...mapActions(['login', 'loginOtp']),

		onLogin() {
			this.login({ username: this.username, password: this.password }).then((res) => {

				const { redirect } = this.$route.query;
				if(res.otp == true) {
					this.showOTP = true
				} else {
					this.redirect()
				}
			});
		},
		onOtp() {
			this.loginOtp({ username: this.username, otp_code: this.otpCode }).then(() => {
				this.redirect()
			});
		},
		redirect() {
			const { redirect } = this.$route.query;

			if (redirect) {
				this.$router.push('/');
			} else {
				this.$router.push({ name: 'dashboard' });
			}
		},
		showPassword() {
			var x = document.getElementById("in-password");
			if (x.type === "password") {
				x.type = "text"
				this.sPassword = false
			} else {
				x.type = "password"
				this.sPassword = true
			}
		},
	},
	created() {
		this.$store.dispatch('setPageTitle', 'Login');
	},
	beforeDestroy() {
		this.reset();
	},
}
</script>